
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    DocumentsTree: () => import("@/modules/Documents/DocumentsTree.vue"),
  },
})
export default class VCompanyDocumentsBrowse extends Vue {}
